var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10C13.6642 10 14 10.3358 14 10.75V13.25C14 13.6642 13.6642 14 13.25 14H2.75C2.33579 14 2 13.6642 2 13.25V10.75C2 10.3358 2.33579 10 2.75 10C3.16421 10 3.5 10.3358 3.5 10.75V12.5H12.5V10.75C12.5 10.3358 12.8358 10 13.25 10ZM8.49902 2C9.05213 2 9.49902 2.42072 9.49902 2.94141V5.76562H11.499C11.7021 5.76562 11.8838 5.88014 11.9619 6.05664C12.0399 6.23305 11.9961 6.436 11.8525 6.56836L8.35254 9.86328C8.15886 10.0456 7.84025 10.0455 7.64648 9.86328L4.14648 6.56836C4.00274 6.43304 3.96211 6.2302 4.03711 6.05664C4.11208 5.88322 4.29608 5.76577 4.49902 5.76562H6.49902V2.94141C6.49902 2.42082 6.94605 2.00015 7.49902 2H8.49902Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIco16);
export default __webpack_public_path__ + "static/media/Download_ico_16.5fe137f3bb374f51da1cfee3c4d275ff.svg";
export { ForwardRef as ReactComponent };